<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        MAXIMA – Ente di Formazione e Agenzia per il Lavoro
Accreditato dalla Regione Campania (DGR n. 13/22), operiamo da oltre 20 anni al fianco di persone e imprese, progettando percorsi formativi finanziati, tirocini e soluzioni su misura per il lavoro
                    </p>
                    <p>
                        Siamo specialisti nella consulenza aziendale per la formazione, l’accesso agli incentivi e le politiche attive. Connettiamo competenze e opportunità per far crescere il capitale umano e il tessuto produttivo del territorio.
                    </p>
                    <ul class="social-link d-none">
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>LOGIN</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Menù</a></li>
                        <li><a href="#" target="_blank">Docenti/Tutor</a></li>
                        <li><a href="#" target="_blank">Partner</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Sede Didattica<br>Via San Leonardo 31/34<br>80044 Ottaviano (Napoli)</li>
                        <li><i class='bx bx-map'></i>Sede Didattica<br>Via XX Settembre N° 45/ interno corte<br>80047 San Giuseppe Vesuviano (Napoli)</li>
                        <li><i class='bx bx-map'></i>Segreteria e Sede Ammnistrativa<br>Via Armando Diaz. 24<br>80047 San Giuseppe Vesuviano (Napoli)</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390813385836">Telefono: (+39) 081-3385836</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@formazionemaxima.com">info@formazionemaxima.com</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390813385836">Lunedì-Venerdì<br>09:30/13:00 – 16:30/20:30</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2026 Maxima Formazione - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
